import { render, staticRenderFns } from "./ErrorsContainer.vue?vue&type=template&id=b226c8f2&"
import script from "./ErrorsContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports